import { KpiCard } from "@/components/KpiCard";
import { formatMoneyWhole } from "@/lib/format";
import { useHomeShared } from "./HomeShared";

/**
 * ef-061-4 — the Home "Next payroll" tile: the roster's gross wages (summed from the roster the API already
 * returned, in the shared Home state) and the headcount line. Same output as before the tile shell.
 */
export function NextPayrollTile() {
  const { nextPayrollGross, employees } = useHomeShared();
  return (
    <KpiCard
      label="Next payroll"
      value={nextPayrollGross === null ? "—" : formatMoneyWhole(nextPayrollGross)}
      detail={
        employees === null
          ? "Loading roster"
          : // Not "1 employees": PayrollCard renders this same fact correctly, and the two must agree.
            `Friday · ${employees.length} employee${employees.length === 1 ? "" : "s"}`
      }
    />
  );
}
